/* eslint-disable */
import * as React from 'react';

const InsightBlock = ({ children: children, insighttype, sourcename, sourcedate, sourcetitle, sourceurl}) => {

    let className = 'ins-blk';
    const insightWord = insighttype;
    if (insighttype === "Research Insight"){className += ' in-ins';}
    else if (insighttype === "UX Law"){className += ' in-ux';}
    else if (insighttype === "User Research"){className += ' in-re';}
    else if (insighttype === "Helpful Hint"){className += ' in-ins'}
    
    let sourceCheck;
    if(sourcename === "" || sourcename === null) {
        sourceCheck = null
    } else {
        sourceCheck = <div className="ins-src">
                        [Source] {sourcename}  ({sourcedate}). {sourcetitle}. <br/>
                        Retrieved from <a target="_blank" href={sourceurl}>{sourceurl}</a>
                      </div>
    } 

    if (insighttype === "Helpful Hint") {
        return (
            <div className={className}>
                <div className="ins-ty">{insighttype}</div>
                <div className="ins-mc">
                    <div className="ins-cnt">{children}</div>
                </div>
            </div>
        )
    }

        return (
            <div className={className}>
                <div className="ins-ty">{insighttype}</div>
                <div className="ins-mc">
                    <div className="ins-cnt">{children}</div>
                    {sourceCheck}
                </div>
            </div>
        )
    };
     
export default InsightBlock;







